module.exports = __webpack_public_path__ + "img/KM-360A_05.0d3abb8c.jpg";